<header class="main-header">
    <!-- Logo -->
    <a href="" class="logo">
        <!-- mini logo for sidebar mini 50x50 pixels -->
        <span class="logo-mini"><b>sm<span class="logo-o-wrap">o<span class="logo-hash">#</span></span></b></span>
        <!-- logo for regular state and mobile devices -->
        <img src="./assets/images/logo-green.svg" class="logo-image" alt="Company Logo Image">
    </a>
    <!-- Header Navbar: style can be found in header.less -->
    <nav class="navbar navbar-static-top">
        <!-- Sidebar toggle button-->
        <a href="#" class="sidebar-toggle" data-toggle="push-menu" role="button">
            <i class="fas fa-bars"></i>
        </a>

        <div class="navbar-custom-menu">
            <ul class="nav navbar-nav">
                <ng-container *ngIf="!isAnonymous; else guestActions">
                    <li class="dropdown notifications-menu academy-indicator-menu">
                        <a href="#" class="dropdown-toggle" data-toggle="dropdown">
                            <i class="fa fa-book-reader"></i>
                            <span class="label label-warning">{{ indicators.coursesInProgress }}</span>
                        </a>
                        <ul class="dropdown-menu">
                            <li class="header">Você possui <b>{{ indicators.coursesInProgress }}</b> cursos em
                                andamento.</li>
                            <li class="footer"><a [routerLink]="'/meus-cursos/em-andamento'">Ver meus cursos</a></li>
                        </ul>
                    </li>

                    <li class="dropdown notifications-menu academy-indicator-menu">
                        <a href="#" class="dropdown-toggle" data-toggle="dropdown">
                            <i class="fa fa-route"></i>
                            <span class="label label-primary">{{ indicators.tracksInProgress }}</span>
                        </a>
                        <ul class="dropdown-menu">
                            <li class="header">Você possui <b>{{ indicators.tracksInProgress }}</b> trilhas ativas no
                                momento.</li>
                            <li class="footer"><a [routerLink]="'/minhas-trilhas/em-andamento'">Ver minhas trilhas</a>
                            </li>
                        </ul>
                    </li>

                    <li class="dropdown notifications-menu academy-indicator-menu">
                        <a href="#" class="dropdown-toggle" data-toggle="dropdown">
                            <i class="fa fa-certificate"></i>
                            <span class="label label-success">{{ indicators.certificatesAvailable }}</span>
                        </a>
                        <ul class="dropdown-menu">
                            <li class="header">Você tem <b>{{ indicators.certificatesAvailable }}</b> certificados
                                disponíveis para consulta.</li>
                            <li class="footer"><a [routerLink]="'/certificados'">Ver certificados</a></li>
                        </ul>
                    </li>

                    <li class="dropdown notifications-menu academy-indicator-menu">
                        <a href="#" class="dropdown-toggle" data-toggle="dropdown">
                            <i class="fa fa-comments"></i>
                            <span class="label label-info">{{ indicators.unreadMessages }}</span>
                        </a>
                        <ul class="dropdown-menu">
                            <li class="header">Você tem <b>{{ indicators.unreadMessages }}</b> mensagem(ns) não lida(s).
                            </li>
                            <li class="footer"><a [routerLink]="'/meus-chats'">Ver mensagens</a></li>
                        </ul>
                    </li>

                    <li class="dropdown tasks-menu academy-indicator-menu" *ngIf="false">
                        <a href="#" class="dropdown-toggle" data-toggle="dropdown">
                            <i class="fa fa-calendar-alt"></i>
                            <span class="label label-danger">{{ 0 }}</span>
                        </a>
                        <ul class="dropdown-menu">
                            <li class="header">Existem <b>{{ 0 }}</b> aulas, encontros ou prazos próximos.</li>
                            <li class="footer"><a [routerLink]="'/agenda'">Ver agenda</a></li>
                        </ul>
                    </li>

                    <li class="dropdown user user-menu">
                        <a href="#" class="-toggle" data-toggle="" data-izimodal-open="#modal_mudar_estabelecimento">
                            <img src="./assets/images/user.png" class="user-image" alt="User Image">
                            <span class="hidden-xs">{{ username }}</span>
                        </a>
                    </li>

                    <li>
                        <a href="#" data-toggle="control-sidebar" (click)="$event.preventDefault(); logout()">
                            <i class="fa fa-sign-out-alt"></i>
                        </a>
                    </li>
                </ng-container>

                <ng-template #guestActions>
                    <li class="dropdown notifications-menu academy-indicator-menu hidden-xs">
                        <a href="#" class="dropdown-toggle" data-toggle="dropdown">
                            <i class="fa fa-compass"></i>
                            <span class="label label-success">{{ 0 }}</span>
                        </a>
                        <ul class="dropdown-menu">
                            <li class="header">Novos cursos e trilhas serão destacados aqui.</li>
                            <li class="footer"><a [routerLink]="'/catalogo/cursos'">Explorar catálogo</a></li>
                        </ul>
                    </li>

                    <li class="academy-auth-item">
                        <button ejs-button type="button" cssClass="e-small academy-auth-sync-btn"
                            iconCss="fa fa-sign-in-alt" (click)="redirectToLogin()">
                            Entrar
                        </button>
                    </li>

                    <li class="academy-auth-item" *ngIf="false">
                        <button ejs-button type="button" cssClass="e-small academy-auth-sync-btn"
                            iconCss="fa fa-user-plus" [isPrimary]="true" [routerLink]="'/login'"
                            [queryParams]="{ mode: 'cadastro' }">
                            Criar cadastro
                        </button>
                    </li>
                </ng-template>
            </ul>
        </div>
    </nav>
</header>